import { useState, useEffect, useCallback } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useProfile } from "./useProfile";
import { Database } from "@/integrations/supabase/types";

type ClassTrial = Database['public']['Tables']['class_trials']['Row'];

export const useTeacherTrials = () => {
  const [trials, setTrials] = useState<ClassTrial[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const { profile } = useProfile();

  const fetchTrials = useCallback(async () => {
    if (!profile?.teacher_id) {
      setTrials([]);
      setIsLoading(false);
      return;
    }

    setIsLoading(true);
    const { data, error } = await supabase
      .from("class_trials")
      .select("*")
      .eq("teacher_code", profile.teacher_id)
      .order("class_date", { ascending: false });

    if (error) {
      console.error("Error fetching teacher trials:", error.message);
    } else {
      setTrials(data || []);
    }
    setIsLoading(false);
  }, [profile?.teacher_id]);

  useEffect(() => {
    fetchTrials();
  }, [fetchTrials]);

  return { trials, isLoading, refetch: fetchTrials, teacherId: profile?.teacher_id };
};
